import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';

import styles from './adgm-breadcrumbs-jss';
import './style.css';

const ADGMBreadcrumbs = props => {
  const { classes, paths } = props;

  return (
    <div className={classNames(classes.container)}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize='small' />}
        className={classes.breadcrumbs}
        aria-label='breadcrumb'
      >
        {paths.map(path => {
          return path.to ? (
            isFunction(path.to) ? (
              <Button
                className={classes.btn}
                key={path.text || Math.random()}
                onClick={path.to}
                disableRipple
                disableFocusRipple
              >
                {path.addArrow && <ArrowBackIcon className='arrowBackIcon' />}
                {path.text}
              </Button>
            ) : (
              <Link
                to={{ pathname: path.to, ...(path.search && { search: path.search }) }}
                className={classes.routerLink}
                key={path.to}
              >
                {path.text}
              </Link>
            )
          ) : (
            <p className={classes.activelink} key={path.text || Math.random()}>
              {path.text}
            </p>
          );
        })}
      </Breadcrumbs>
    </div>
  );
};

ADGMBreadcrumbs.propTypes = {
  classes: PropTypes.object.isRequired,
  paths: PropTypes.array.isRequired,
};

export default React.memo(withStyles(styles)(ADGMBreadcrumbs));
